import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const LandingPageFeatures = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12722"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12722)">
          <rect
            x="-4"
            y="-2"
            width="122"
            height="115"
            rx="5.60951"
            fill="#FFEDBF"
          />
          <path
            d="M93.377 35.076V86.2483C93.377 87.9448 92.7031 89.5718 91.5035 90.7713C90.3039 91.9709 88.6769 92.6448 86.9805 92.6448H26.2134C24.517 92.6448 22.89 91.9709 21.6904 90.7713C20.4908 89.5718 19.8169 87.9448 19.8169 86.2483V35.076H93.377Z"
            fill="#66E1FF"
          />
          <path
            d="M19.8169 35.076V86.2483C19.8169 87.9448 20.4908 89.5718 21.6904 90.7713C22.89 91.9709 24.517 92.6448 26.2134 92.6448H29.4117L86.9805 35.076H19.8169Z"
            fill="#C2F3FF"
          />
          <path
            d="M93.377 35.0762H19.8169V25.4814C19.8169 23.7849 20.4908 22.1579 21.6904 20.9583C22.89 19.7588 24.517 19.0848 26.2134 19.0848H86.9805C88.6769 19.0848 90.3039 19.7588 91.5035 20.9583C92.7031 22.1579 93.377 23.7849 93.377 25.4814V35.0762Z"
            fill="white"
          />
          <path
            d="M86.9805 19.0848H26.2134C24.517 19.0848 22.89 19.7588 21.6904 20.9583C20.4908 22.1579 19.8169 23.7849 19.8169 25.4814V86.2484C19.8169 87.9449 20.4908 89.5719 21.6904 90.7715C22.89 91.971 24.517 92.645 26.2134 92.645H86.9805C88.6769 92.645 90.3039 91.971 91.5035 90.7715C92.7031 89.5719 93.377 87.9449 93.377 86.2484V25.4814C93.377 23.7849 92.7031 22.1579 91.5035 20.9583C90.3039 19.7588 88.6769 19.0848 86.9805 19.0848Z"
            stroke="#191919"
            strokeWidth="1.05178"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.8169 35.076H93.377"
            stroke="#191919"
            strokeWidth="1.05178"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M31.0107 27.8799C30.7987 27.8799 30.5953 27.7957 30.4454 27.6457C30.2954 27.4958 30.2112 27.2924 30.2112 27.0803C30.2112 26.8683 30.2954 26.6649 30.4454 26.5149C30.5953 26.365 30.7987 26.2808 31.0107 26.2808"
            stroke="#191919"
            strokeWidth="1.05178"
          />
          <path
            d="M31.0107 27.8799C31.2228 27.8799 31.4262 27.7957 31.5761 27.6457C31.7261 27.4958 31.8103 27.2924 31.8103 27.0803C31.8103 26.8683 31.7261 26.6649 31.5761 26.5149C31.4262 26.365 31.2228 26.2808 31.0107 26.2808"
            stroke="#191919"
            strokeWidth="1.05178"
          />
          <path
            d="M40.6057 27.8799C40.3937 27.8799 40.1903 27.7957 40.0403 27.6457C39.8904 27.4958 39.8062 27.2924 39.8062 27.0803C39.8062 26.8683 39.8904 26.6649 40.0403 26.5149C40.1903 26.365 40.3937 26.2808 40.6057 26.2808"
            stroke="#191919"
            strokeWidth="1.05178"
          />
          <path
            d="M40.6057 27.8799C40.8178 27.8799 41.0211 27.7957 41.1711 27.6457C41.321 27.4958 41.4053 27.2924 41.4053 27.0803C41.4053 26.8683 41.321 26.6649 41.1711 26.5149C41.0211 26.365 40.8178 26.2808 40.6057 26.2808"
            stroke="#191919"
            strokeWidth="1.05178"
          />
          <path
            d="M50.2004 27.8799C49.9884 27.8799 49.785 27.7957 49.6351 27.6457C49.4851 27.4958 49.4009 27.2924 49.4009 27.0803C49.4009 26.8683 49.4851 26.6649 49.6351 26.5149C49.785 26.365 49.9884 26.2808 50.2004 26.2808"
            stroke="#191919"
            strokeWidth="1.05178"
          />
          <path
            d="M50.2004 27.8799C50.4125 27.8799 50.6159 27.7957 50.7658 27.6457C50.9158 27.4958 51 27.2924 51 27.0803C51 26.8683 50.9158 26.6649 50.7658 26.5149C50.6159 26.365 50.4125 26.2808 50.2004 26.2808"
            stroke="#191919"
            strokeWidth="1.05178"
          />
          <circle
            cx="33.8084"
            cy="45.6977"
            r="2.27887"
            stroke="black"
            strokeWidth="1.05178"
          />
          <path
            d="M42.3643 43.3132H76.1236"
            stroke="#191919"
            strokeWidth="1.05178"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.3645 48.0822H69.1542"
            stroke="#191919"
            strokeWidth="1.05178"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="33.8084"
            cy="56.9168"
            r="2.27887"
            stroke="black"
            strokeWidth="1.05178"
          />
          <path
            d="M42.3645 56.9169H69.1542"
            stroke="#191919"
            strokeWidth="1.05178"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="33.8084"
            cy="68.1359"
            r="2.27887"
            stroke="black"
            strokeWidth="1.05178"
          />
          <path
            d="M42.3643 65.751H76.1236"
            stroke="#191919"
            strokeWidth="1.05178"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.3645 70.5206H69.1542"
            stroke="#191919"
            strokeWidth="1.05178"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="33.8084"
            cy="79.3547"
            r="2.27887"
            stroke="black"
            strokeWidth="1.05178"
          />
          <path
            d="M42.3645 79.3549H76.1239"
            stroke="#191919"
            strokeWidth="1.05178"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SvgIcon>
    );
  })
);
